export const CtoAsks = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'CTO Asks',
  url: 'https://www.boldare.com/CTO-asks/',
  description:
    'A series of expert answers to the most important and challenging questions CTOs face in digital product development. Curated by Boldare’s experienced tech leaders, this resource helps CTOs make informed decisions and overcome common technology and business challenges.',
  publisher: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
  },
};
